import { render, staticRenderFns } from "./c_set_up.vue?vue&type=template&id=42b10ac6&scoped=true&"
import script from "./c_set_up.vue?vue&type=script&lang=js&"
export * from "./c_set_up.vue?vue&type=script&lang=js&"
import style0 from "./c_set_up.vue?vue&type=style&index=0&id=42b10ac6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b10ac6",
  null
  
)

export default component.exports